(function (root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD
    define(['torso/modules/NestedModel', 'app/urls'], factory);
  } else if (typeof exports === 'object') {
    // Node, CommonJS-like
    module.exports = factory(require('backbone-torso/modules/NestedModel'), require('./../urls'));
  } else {
    throw 'Only AMD and CommonJS imports are supported.';
  }
}(this, function (TorsoNestedModel, urls) {
  'use strict';

  /**
   * Model for creating user log entries. Uses the UserLogExtService and corresponds to a UserLogEntryDTO
   *
   * @class UserLogEntryModel
   * @extends Torso.NestedModel
   * @constructor
   */
  return TorsoNestedModel.extend({
    urlRoot: urls.userLogEntryService
  });
}));
